import { render } from "./Join4.vue?vue&type=template&id=4c8eb92b"
import script from "./Join4.vue?vue&type=script&lang=js"
export * from "./Join4.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__